import BigCard from "../../dashboard/card/BigCard";
import LineChartComponent from "../../plots/LineChartComponent";
import AreaChartComponent from "../../plots/AreaChartComponent";
import { Container, Image } from "react-bootstrap";
import { useRef } from "react";
import { toPng } from "html-to-image";

interface GraphCardProps {
  fileId: string;
  sensor_id: string;
  title: string;
  id: string;
  bigHeading?: boolean;
  xKey?: string;
  yKey?: string | Array<string>;
  plotData?: any[];
}

export default function GraphCard(props: GraphCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (cardRef.current) {
      toPng(cardRef.current)
        .then((dataUrl) => {
          const link = document.createElement('a');
          link.download = `${props.title}-chart.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch((error) => {
          console.error('Error generating PNG:', error);
        });
    }
  };

  // Pass the download handler to the chart components
  const downloadHandler = handleDownload;
  function renderChart(
    xKey: string | undefined,
    yKey: string | Array<string> | undefined
  ) {
    if (xKey === undefined || yKey === undefined) {
      return <p>Invalid keys specified</p>;
    }
    
    // Convert single string yKey to array for consistent handling
    const yKeyArray = Array.isArray(yKey) ? yKey : [yKey];
    
    // Use LineChartComponent for multi-series data or specific combined graphs
    if (yKeyArray.length > 1 || 
        props.id === "speed_combined" || 
        props.id === "apparentWindAngles_combined") {
      return (
        <LineChartComponent
          fileId={props.fileId}
          sensorId={props.sensor_id}
          xKey={xKey}
          yKey={yKeyArray}
          plotData={props.plotData}
          onDownload={downloadHandler}
        />
      );
    } else {
      // Use AreaChartComponent for single series data
      return (
        <AreaChartComponent
          fileId={props.fileId}
          sensorId={props.sensor_id}
          xKey={xKey}
          yKey={yKeyArray}
          plotData={props.plotData}
          onDownload={downloadHandler}
        />
      );
    }
  }

  return (
    <div ref={cardRef}>
      <BigCard
        heading={props.title}
        key={props.title}
        button={
          <Image
            src="/img/logo_powered_by_windpuls_grey.png"
            height={"50rem"}
          />
        }
      content={
        <div
          style={{ height: "30vh" }}
        >
          {renderChart(props.xKey, props.yKey)}
        </div>
      }
      subheading=""
      bigHeading={props.bigHeading}
    />
    </div>
  );
}
